import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

import { AppRoutes } from 'config/routes';

import { isOverviewViewer } from './permissions';

interface AuthState {
  auth?: {
    user?: { role?: { name?: string }; features?: string[] | null };
  };
}

// The signed-in role and features, read straight from the auth slice: the
// guard sits in the route table, so it stays free of the store's API modules.
const selectRole = (state: AuthState) => state.auth?.user?.role?.name;
const selectFeatures = (state: AuthState) => state.auth?.user?.features;

const EXPENSES = `${AppRoutes.Accounting.Home}/${AppRoutes.Accounting.Expenses.Home}`;
const OVERVIEW = `${AppRoutes.Accounting.Home}/${AppRoutes.Accounting.Overview.Home}`;

const useViewer = () => {
  const role = useSelector(selectRole);
  const features = useSelector(selectFeatures);
  return isOverviewViewer(role, features);
};

/**
 * ACCOUNTING OVERVIEW route guard (plan §5, Q14): only Company Owner,
 * Accounting and Administrative with the Accounting feature open
 * /accounting/overview; anyone else lands on today's Expenses.
 */
export const AccountingOverviewRouteGuard = ({
  children,
}: PropsWithChildren) => {
  if (!useViewer()) {
    return <Navigate replace to={EXPENSES} />;
  }
  return children || <Outlet />;
};

/** /accounting: the Overview for its viewers (Q6), Expenses as today for
 * everyone else. */
export const AccountingIndexRedirect = () => {
  const viewer = useViewer();
  return <Navigate replace to={viewer ? OVERVIEW : EXPENSES} />;
};
